import { useMemo } from 'react';

import { ComponentStates } from '../../../enums/component-states';
import { useFulfillmentPlannerContext } from '../../../fulfillment-planner/context';
import { useIsFulfillmentPlanThirdPartyBilling } from '../../../fulfillment-planner/hooks/use-is-fulfillment-plan-third-party-billing';

export const useFulfillmentPlanRateInfo = (labelProviderServiceId) => {
  const { uiRestrictions, otherShippingOptions } = useFulfillmentPlannerContext();

  const isThirdPartyBilling = useIsFulfillmentPlanThirdPartyBilling(labelProviderServiceId, otherShippingOptions);
  const hasProvidedRate = uiRestrictions?.rateSummary?.componentState === ComponentStates.Provided;

  return useMemo(
    () => ({
      isThirdPartyBilling,
      hasProvidedRate,
    }),
    [hasProvidedRate, isThirdPartyBilling],
  );
};
